<script setup>
// Notatka trafia tylko do Notatnika — nie ma terminu i nie pojawia się w planerze.
// Tytuł jest opcjonalny — bez niego notatka pokazuje się jako sam cytat.
import { useI18n } from 'vue-i18n';

defineProps({
    draft: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
</script>

<template>
    <div>
        <input
            v-model="draft.title"
            type="text"
            class="v2-input mb-3"
            :placeholder="t('entry.note.titlePlaceholder')"
        />

        <textarea
            v-model="draft.content"
            rows="4"
            class="v2-freetext"
            :placeholder="t('entry.note.contentPlaceholder')"
            :aria-invalid="!!errors.content"
        ></textarea>
        <p v-if="errors.content" class="text-[11.5px] text-[#B5643C]">{{ errors.content }}</p>
    </div>
</template>
